import FormInstitution from "../../../components/forms/formInstitution";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";

const Settings = () => {
  return (
    <>
      <HeaderTitle title="Configurações" />

      <FormInstitution />
    </>
  );
};

export default Settings;
